<template>
  <div>
    <b-row>
      <b-col md="8" style="text-align: right;">{{selected_item_text || "Select Dropdown"}} Storage Space</b-col>
      <b-col md="4" style="text-align: left;">
        <b-button-group v-b-hover="handleHover" vertical>
          <b-button size="sm" v-if="showUndo"
            :variant="isHovered ? 'warning' : 'primary'"
            class="mb-2"
            v-b-tooltip.hover.right title="Select Storage Space"
            @click="unsetSelection"
            >
            <b-icon-arrow-clockwise aria-label="Undo"></b-icon-arrow-clockwise>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <div v-if="showTable">
      <storage-space-select
        :select_table_heading="no_heading"
        :filtering="collection_id_filtering"
        @selectedItems="setStorageSpace"
      >
      </storage-space-select>
    </div>
  </div>
</template>

<script>
import StorageSpaceSelect from './StorageSpaceSelect.vue'
import {
  BIconArrowClockwise
} from 'bootstrap-vue'

export default {
  components: {
    StorageSpaceSelect,
    BIconArrowClockwise
  },
  props: {
    collection_id: String,
    heading: {
      Type: String
    },
    filtering: {
      Type: Object
    }
  },
  data () {
    return {
      isHovered: false,
      storage_space_id: undefined,
      selected_item_text: undefined,
      collection_id_filtering: {
        collection_ids: this.collection_id,
        ...this.filtering
      },
      no_heading: ""
    }
  },
  computed: {
    showUndo() {
      return this.storage_space_id !== undefined
    },
    showTable() {
      return this.storage_space_id === undefined
    }
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered
    },
    setStorageSpace(items) {
      this.storage_space_id = items[0].id
      this.selected_item_text = items[0].attributes['location']
      this.$emit('selectedItems', items)
    },
    unsetSelection() {
      this.storage_space_id = undefined
      this.selected_item_text = undefined
    }
  }
}
</script>
